import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './Typography.styles';

export const variants = {
  title: 'title',
  mainTitle: 'mainTitle',
  headline1: 'headline1',
  headline2: 'headline2',
  headline3: 'headline3',
  largeLabel: 'largeLabel',
  smallLabel: 'smallLabel',
  linkTitle: 'linkTitle',
  subtitle: 'subtitle',
  disclaimer: 'disclaimer'
};

export const weights = {
  light: 'light',
  medium: 'medium',
  heavy: 'heavy'
};

const Typography = ({ children, className, dataQa, style, tag, variant, weight }) => {
  const classes = useStyles();
  const Tag = tag;
  return (
    <Tag
      style={style}
      className={`${classes[variant]} ${classes[weight]} ${className}`}
      data-qa={dataQa}
    >
      {children}
    </Tag>
  );
};

Typography.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  dataQa: PropTypes.string,
  style: PropTypes.shape({}),
  tag: PropTypes.string,
  variant: PropTypes.string,
  weight: PropTypes.string
};

Typography.defaultProps = {
  className: '',
  dataQa: null,
  style: {},
  tag: 'div',
  variant: 'default',
  weight: 'regular'
};

export default Typography;
